define(['./namespace.js', './bootstrap.js', './config.js', './extend.js', './util.js', './formatting',
    './validation/index', './instance-registry.js', './config-evaluator.js', './meta.js', './component-init.js', './context.js'
], function(namespace, bootstrap, config, extend, util, formatting, validation, instanceRegistry, ConfigEvaluator, meta, componentInit, context) {
    'use strict';

    function createAsterix() {
        if (util.isEmptyObject(morningstar.asterix)) {
            morningstar.asterix = {
                register: namespace.register,
                reset: namespace.reset,
                noConflict: namespace.noConflict,
                config: config,
                extend: extend,
                util: util,
                formatting: formatting,
                validation: validation,
                instanceRegistry: instanceRegistry,
                ConfigEvaluator: ConfigEvaluator,
                bootstrap: bootstrap,
                meta: meta,
                context: context
            };
        }
    }

    createAsterix();
    morningstar.initComponent = componentInit.init;

    return {
        createAsterix: createAsterix
    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/_entrypoint.js
 ** module id = 0
 ** module chunks = 0
 **/